import {
    Card,
    CardContent,
    Typography,
    Stack,
    Button,
    Chip,
    Divider,
    Grid,
    TextField,
    IconButton,
    InputAdornment
} from "@mui/material";
import { useEffect, useState } from "react";
import { useAppDispatch } from '../../../../store/store';
import { RootState } from '../../../../reducers';
import CircularProgress from '@mui/material/CircularProgress';
import { fetchMedmUser, createMedMUser, setMedmUser, fetchMedmUserPassword } from '../../../../store/memberDetail.slice';
import { useSelector } from "react-redux";
import { Visibility, VisibilityOff } from "@mui/icons-material";


const MedMUserAccount = () => {
    const dispatch = useAppDispatch();
    const { medMUser, selectedMember } = useSelector((state: RootState) => state.memberDetail);
    const [error, setError] = useState({ email: false, password: false });
    const [isSaving, setIsSaving] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [loadingPassword, setLoadingPassword] = useState(false);

    useEffect(() => {
        dispatch(fetchMedmUser(selectedMember.Id));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const valid = (userPassword: boolean) => {
        if (!medMUser.Email || (userPassword && !medMUser.Password)) {
            setError({ ...error, email: !medMUser.Email, password: !medMUser.Password });
            return false;
        } else {
            return true;
        }
    };

    const saveAccount = async () => {
        if (valid(false)) {
            try {
                setIsSaving(true);
                await dispatch(
                    createMedMUser(medMUser, (data) => {
                        dispatch(setMedmUser({ ...medMUser, IsAccountCreated: data }));
                    })
                );
            } finally {
                setIsSaving(false);
            }
        }
    };

    const handleRevealPassword = async () => {
        if (showPassword) {
            setShowPassword(false);
            return;
        }

        try {
            setLoadingPassword(true);
            await dispatch(fetchMedmUserPassword(selectedMember.Id, (password) => {
                dispatch(setMedmUser({ ...medMUser, Password: password }));
            }));
            setShowPassword(true);
        } catch (error) {
            console.error("Failed to fetch password", error);
        } finally {
            setLoadingPassword(false);
        }
    };

    return (
        <>
            <Card sx={{ borderRadius: 3 }}>
                <CardContent>

                    {/* Header */}
                    <Grid container alignItems="center" justifyContent="space-between">

                        {/* Left: Title + Status */}
                        <Grid>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Typography variant="h6">
                                    MedM Account
                                </Typography>
                                <Chip
                                    label={medMUser?.IsAccountCreated ? "Created" : "Not Created"}
                                    color={medMUser?.IsAccountCreated ? "success" : "warning"}
                                    size="small"
                                />
                            </Stack>
                        </Grid>

                    </Grid>

                    <Divider sx={{ my: 3 }} />

                    {/* Form Fields */}
                    <Grid container spacing={3}>
                        <Grid size={4}>
                            <TextField
                                fullWidth
                                label="Email"
                                value={medMUser.Email}
                                error={error.email}
                                helperText={error.email ? "Required" : ""}
                                onChange={(e) => {
                                    dispatch(setMedmUser({ ...medMUser, Email: e.target.value }));
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            {
                                medMUser.IsAccountCreated ? (<TextField
                                    fullWidth
                                    type={showPassword ? "text" : "password"}
                                    label="Password"
                                    value={medMUser.Password || ""}
                                    error={error.password}
                                    helperText={error.password ? "Required" : ""}
                                    InputProps={{
                                        readOnly: true, // always readonly
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={handleRevealPassword}
                                                    edge="end"
                                                    disabled={loadingPassword}
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />) : (<TextField
                                    fullWidth
                                    type="text"
                                    label="Password"
                                    value={medMUser.Password}
                                    error={error.password}
                                    helperText={error.password ? "Required" : ""}
                                    onChange={(e) =>
                                        dispatch(setMedmUser({ ...medMUser, Password: e.target.value }))
                                    }
                                />)
                            }
                        </Grid>
                        <Grid>
                            <Stack direction="row" spacing={2} paddingTop={1.5}>
                                <Button
                                    variant="contained"
                                    disabled={
                                        isSaving ||
                                        !medMUser.Email ||
                                        !medMUser.Password ||
                                        medMUser.IsAccountCreated
                                    }
                                    onClick={saveAccount}
                                    endIcon={
                                        isSaving ? <CircularProgress size={18} color="inherit" /> : null
                                    }
                                >
                                    {isSaving ? "Creating" : "Create Account"}
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="error"
                                    disabled
                                >
                                    Delete Account
                                </Button>
                            </Stack>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            {/* 
            <Dialog open={openCreate} onClose={() => setOpenCreate(false)}>
                <DialogTitle>Create MedM Account</DialogTitle>
                <DialogContent>
                    <Typography>
                        This will create a MedM account for this member.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenCreate(false)}>Cancel</Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            onCreate();
                            setOpenCreate(false);
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
                <DialogTitle>Delete MedM Account</DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to delete this account?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDelete(false)}>Cancel</Button>
                    <Button
                        color="error"
                        variant="contained"
                        onClick={() => {
                            onDelete();
                            setOpenDelete(false);
                        }}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog> */}
        </>
    );
}

export default MedMUserAccount;